export const normalizedNumber = (number: number) => (number ? +`${number}`.replace(',', '.') : number);

export const numberFromString = (number: String) =>
  number
    ? +`${number}`
        .replaceAll(/\u00A0/g, '')
        .replaceAll(' ', '')
        .replace(',', '.')
    : null;

export const formatPrice = (number: number | null, minimumFractionDigits = 2) =>
  (number || 0).toLocaleString('ru-RU', { minimumFractionDigits: minimumFractionDigits, maximumFractionDigits: 2 });
